import { Component, Input, OnInit } from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable,
} from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyListFilterState } from '@app/component/survey-list-filter/survey-list-filter-state';
import { BeneficiaryGroupApi } from '@shared/beneficiary/beneficiary-group-api.service';
import { BeneficiaryGroupSurveySummary } from '@shared/beneficiary/beneficiary-group-survey-summary';

@Component({
  selector: 'app-survey-summary-widget',
  templateUrl: 'survey-summary-widget.component.html',
  styleUrls: ['survey-summary-widget.component.scss'],
  imports: [
    MatTable,
    MatHeaderCell,
    MatCell,
    MatColumnDef,
    MatHeaderCellDef,
    MatCellDef,
    MatHeaderRow,
    MatRow,
    MatRowDef,
    MatHeaderRowDef,
  ],
})
export class SurveySummaryWidgetComponent implements OnInit {
  summaries!: BeneficiaryGroupSurveySummary[];

  @Input() status!: string;
  @Input() includeComments = false;

  displayedColumns = ['group', 'round', 'amount'];

  constructor(
    private readonly beneficiaryGroupApi: BeneficiaryGroupApi,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.status = this.status ? this.status : this.route.snapshot.data.status;
    this.includeComments = this.includeComments ? this.includeComments : this.route.snapshot.data.includeComments;

    this.beneficiaryGroupApi.summaryPerStatus(this.status).subscribe(value => {
      this.summaries = value;
      this.summaries.sort(this.sort);
    });
    if (this.includeComments) {
      this.displayedColumns.push('comment');
    }
  }

  protected sort(value1: BeneficiaryGroupSurveySummary, value2: BeneficiaryGroupSurveySummary): number {
    if (!value1) {
      return 0;
    }

    let result = value1.beneficiaryGroupCode.localeCompare(value2.beneficiaryGroupCode, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
    if (result !== 0) {
      return result;
    }

    result = value1.round.localeCompare(value2.round, undefined, {
      numeric: true,
      sensitivity: 'base',
    });

    return result;
  }

  onRowClick(summary: BeneficiaryGroupSurveySummary): void {
    const state: SurveyListFilterState = {
      searchValues: {
        status: this.status,
        groupUuid: summary.beneficiaryGroupUuid,
        roundName: summary.round,
      },
    };

    this.router.navigate(['/surveys'], { state });
  }
}
